/**
 * Shared constants for Document Signing components
 * Used for any document requiring DocuSign + Regtank liveness verification
 *
 * Current consumers:
 * - ShareholderBoardResolution
 * - ShareholderSPVBoardResolution
 * - MembershipAgreementPage
 * - BMCASigning (Master SKU Financing Agreement)
 * - IssuerBoardResolution
 */

export const COLORS = {
  PRIMARY: "#338F86",
  SECONDARY_BG: "#E5E5E5",
  SECONDARY_TEXT: "#333333",
} as const;

export const SUBSCRIPTION_ERROR_CODES = {
  NOTE_FULLY_SUBSCRIBED: "NOTE_FULLY_SUBSCRIBED",
} as const;

export const MESSAGES = {
  VERIFICATION_REQUIRED:
    "Agreement signing will be available once identity verification is complete.",
  VERIFICATION_DISABLED:
    "Agreement signing is temporarily disabled until a new verification attempt is allowed.",
  ACKNOWLEDGEMENT:
    'By clicking "Proceed to Sign", you acknowledge that you have read, understood and agree to be bound by the agreement above.',
  LOADING_DOC: "Document is loading",
  LOADING_LIVENESS: "Redirecting to Liveness Check URL.",
  SIGNING_SUCCESS: "Document Signed Successfully",
  INVALID_URL: "Invalid verification URL. Please contact support.",
} as const;

export const MODAL_CONTENT = {
  TITLE: "Agreement Signing Unsuccessful",
  PARAGRAPHS: [
    "Your agreement signing could not be completed as your identity verification was unsuccessful.",
    "Our onboarding team is reviewing the matter to identify the issue. Once the review is complete, we will notify you by email and provide guidance on when you may reattempt verification.",
    "Thank you for your patience and understanding.",
  ],
} as const;

export const PARTIAL_SUBSCRIPTION_MESSAGES = {
  TITLE: "Subscription Partially Fulfilled",
  BODY_TEMPLATE: (
    currency: string,
    requestedAmount: string,
    subscribedAmount: string
  ) =>
    `Due to high demand, your subscription was partially fulfilled. You requested ${currency} ${requestedAmount} but ${currency} ${subscribedAmount} was available and has been allocated to your account.`,
} as const;

export const FULLY_SUBSCRIBED_MESSAGES = {
  TITLE: "Note Fully Subscribed",
  BODY: "This note is fully subscribed. Please explore other available notes.",
} as const;
